import { toDate as i } from "./toDate.js";
import { getDefaultOptions as c } from "./_lib/defaultOptions.js";
function O(r, p) {
  var s, a;
  const e = c(), o = e.weekStartsOn ?? ((a = (s = e.locale) == null ? void 0 : s.options) == null ? void 0 : a.weekStartsOn) ?? 0, t = i(r), n = t.getDay(), f = (n < o ? -7 : 0) + 6 - (n - o);
  return t.setDate(t.getDate() + f), t.setHours(23, 59, 59, 999), t;
}
export {
  O as default,
  O as endOfWeek
};
//# sourceMappingURL=endOfWeek.js.map
